/* eslint-disable react/no-array-index-key */
import React, { Component } from "react"
import PropTypes from "prop-types"

// D3
import { pie, arc, lineRadial } from "d3-shape"

// Utils
import { gaugeScale } from "../utils"

const defineSections = score => {
  const percentage = score / 100
  const gaugeSections = [0.2, 0.2, 0.2, 0.2, 0.2]

  // Quadrant logic errors on these specific values, so provide an exception
  const scoreExceptions = [20, 40, 80]
  const minimizingValue = scoreExceptions.includes(score) ? 0 : 1

  // Determining which quadrant of the gauge the score falls into
  const scoreQuadrant =
    score > 1 ? Math.ceil(percentage / 0.2) - minimizingValue : 0

  // Dividing scoreQuadrant into the part that falls below the score
  // and the part that falls above it, for coloring purposes
  const below = percentage % 0.2
  gaugeSections[scoreQuadrant] = below
  gaugeSections.splice(scoreQuadrant + 1, 0, 0.2 - below)

  return { gaugeSections, scoreQuadrant }
}

class Gauge extends Component {
  render() {
    const { score, margin, containerWidth } = this.props
    const svgWidth = containerWidth
    const svgHeight = svgWidth / 1.9

    // Dimensions
    const w = svgWidth - margin.left - margin.right
    const outerR = w / 2
    const innerR = w / 2.3

    // D3 Math
    const d3Pie = pie()
      .startAngle(-Math.PI / 2)
      .endAngle(Math.PI / 2)
      .padAngle(0.01)
      .sort(null)
    const d3Arc = arc()
      .innerRadius(innerR)
      .outerRadius(outerR)
    const d3LineRadial = lineRadial()

    // Data
    const { gaugeSections, scoreQuadrant } = defineSections(score)
    const arcSections = d3Pie(gaugeSections)

    return (
      <svg width={svgWidth} height={svgHeight}>
        <g
          ref={e => {
            this.g = e
          }}
          transform={`translate(${margin.left}, ${margin.top})`}
          className="gauge"
        >
          {arcSections.map((section, i) => {
            return (
              <g
                transform={`translate(${outerR}, ${outerR})`}
                key={`score-g-${i}`}
              >
                <path
                  fill={i > scoreQuadrant ? "#DDE1E7" : gaugeScale(score)}
                  d={d3Arc({
                    innerRadius: innerR,
                    outerRadius: outerR,
                    startAngle: section.startAngle,
                    endAngle: section.endAngle,
                    padAngle: section.padAngle
                  })}
                />
              </g>
            )
          })}
          <g transform={`translate(${outerR}, ${outerR})`}>
            <path
              d={d3LineRadial([
                [arcSections[scoreQuadrant].endAngle, innerR - 4],
                [arcSections[scoreQuadrant].endAngle, outerR + 4]
              ])}
              stroke="#393B3D"
              strokeWidth={3}
              strokeLinecap="round"
            />
          </g>
          <text
            x={w / 2}
            y={w / 2}
            fontSize={`${w / 3.5}px`}
            textAnchor="middle"
            fill={gaugeScale(score)}
            fontWeight="bold"
          >
            {score}
          </text>
        </g>
      </svg>
    )
  }
}

export default Gauge

Gauge.propTypes = {
  containerWidth: PropTypes.number,
  score: PropTypes.number,
  margin: PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number
  })
}

Gauge.defaultProps = {
  containerWidth: 500,
  score: 0,
  margin: {
    top: 10,
    bottom: 10,
    left: 10,
    right: 10
  }
}
